export default {
  bell: {
    title: 'Notifications',
    open: 'Ouvrir les notifications',
    unread: 'Aucune notification non lue | Une notification non lue | {count} notifications non lues',
    markAllRead: 'Tout marquer comme lu',
    manage: 'Gérer mes notifications',
    unreadMarker: 'Non lue',
    loadFailed: "Les notifications n'ont pas pu être chargées.",
    markFailed: "La notification n'a pas pu être marquée comme lue.",
    empty: {
      title: 'Aucune notification',
      description:
        "Ce qui s'affiche ici se choisit dans vos réglages de notifications : activez « Dans l'application » pour les nouveaux fichiers d'un espace, les demandes d'inscription ou les ventes de vos chaînes.",
    },
  },
  lines: {
    uploadReceived: '« {title} » a été ajouté dans {workspace}',
    uploadReceivedBy: '{uploader} a ajouté « {title} » dans {workspace}',
    uploadPendingModeration: '« {title} » attend une validation dans {workspace}',
    uploadPendingModerationBy: '{uploader} a ajouté « {title} » dans {workspace} : il attend une validation',
    membershipRequestReceived: "{name} ({email}) demande à rejoindre l'organisation",
    membershipRequestsWaiting:
      "Aucune demande d'inscription en attente | Une demande d'inscription attend une réponse depuis {days} jours | {count} demandes d'inscription attendent une réponse, la plus ancienne depuis {days} jours",
    saleReceived: '{channel} : nouvelle vente — {what}',
    saleReceivedAmount: '{channel} : nouvelle vente — {what}, {amount} HT',
    subscriptionReceived: '{channel} : nouvel abonnement — {what}',
    subscriptionReceivedAmount: '{channel} : nouvel abonnement — {what}, {amount} HT',
    contactMessageReceived: '{channel} : nouveau message de {name}',
    contactMessageReceivedSubject: '{channel} : nouveau message de {name} — {subject}',
    depositReceived: '{channel} : nouveau dépôt « {title} »',
    depositReceivedBy: '{channel} : {name} a déposé « {title} »',
    depositsReceived: '{channel} : {count} nouveaux fichiers « {title} »',
    depositsReceivedBy: '{channel} : {name} a déposé {count} fichiers « {title} »',
    unknown: "Une notification que cette version de l'application ne sait pas encore décrire.",
  },
}
